import 'styled-components/macro';

import {
  kioskThemeCustomizationSchema,
  kioskThemeCustomizationUiSchema,
} from '../../../../../components/JsonEditor/constants/ThemeSchema/kioskThemeCustomization';

import CustomizeTheme from '../../../../../components/CustomizeTheme';
import { CustomizeThemeLocalizationEntityLevel } from '../../../../../enums/CustomizeThemeLocalizationEntityLevel';
import React from 'react';
import { ThemeComponentName } from '../../../../../enums/ComponentNameEnum';
import { useParams } from 'react-router-dom';

const CustomizeKioskTheme: React.FC<{}> = () => {
  const { kioskId } = useParams<{ kioskId: string }>();

  return (
    <CustomizeTheme
      schema={kioskThemeCustomizationSchema}
      uiSchema={kioskThemeCustomizationUiSchema}
      componentName={ThemeComponentName.KIOSK}
      fileNameToDownloadDefaultJson={`Default Kiosk theme - Kiosk ${kioskId}.json`}
      fileNameToDownloadCurrentJson={`Current Kiosk theme - Kiosk ${kioskId}.json`}
      title="Customize kiosk theme"
      entityLevel={CustomizeThemeLocalizationEntityLevel.KIOSK}
      entityId={kioskId}
    />
  );
};

export default CustomizeKioskTheme;
